'use strict'

export let norwegian_productDetails={
  general: {
    projectManager: "Produktleder"
  },
  themes: {
    plan: {
      title: "Langtidsplan"
    }
  }
};



// WEBPACK FOOTER //
// ./views/product/labels/norwegian#productDetails.js